/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Input from "../../../../component/inputpm";
import Loader from "../../../../component/loader";
import IconButton from "@mui/material/IconButton";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import BillingHistoryTable from "./billingHistoryTable";
import classes from "../reports.module.css";
import moment from "moment";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "../../../../component/tabPanel";
import AppBar from "@mui/material/AppBar";
import { CSVLink } from "react-csv";
import Button from "../../../../component/button";
import BanSelect from "../../../../pages/sales/checkout/customerDetails/banSelect";
import Breadcrumb from "../../../../component/breadcrumb";
import orderClasses from "../../orders/orders.module.css";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { Tooltip } from "@mui/material";
import { SearchIcon, ClearIcon } from "../../../../component/icons/icons";
import { withTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import UriEncode from "../../../../component/uriEncode/uriEncode";
import dateFormat from "dateformat";

// Manage order page class
class BillingHistory extends Component {
  // Declare property values that belongs to the component
  state = {
    tabValue: 0,

    billingHistoryList: [],

    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalHistoryCount: 0,
    sortBy: "createdStamp",
    sortOrder: "DESC",

    agentId: "",
    customerBan: "",
    customerName: "",
    featureCode: "",
    settlementId: "",
    orderId: "",
    itemDescription: "",
    fromDate: "",
    toDate: "",
    fromDateISO: "",
    toDateISO: "",

    csvData: ``,
    download: false,
    loading: false,
    customersList: [],
    monthList: [
      {
        name: "Jan",
        value: 0,
      },
      {
        name: "Feb",
        value: 1,
      },
      {
        name: "Mar",
        value: 2,
      },
      {
        name: "Apr",
        value: 3,
      },
      {
        name: "May",
        value: 4,
      },
      {
        name: "June",
        value: 5,
      },
      {
        name: "July",
        value: 6,
      },
      {
        name: "Aug",
        value: 7,
      },
      {
        name: "Sep",
        value: 8,
      },
      {
        name: "Oct",
        value: 9,
      },
      {
        name: "Nov",
        value: 10,
      },
      {
        name: "Dec",
        value: 11,
      },
    ],
    yearsList: [],

    selectedYear: new Date().getFullYear(),
    selectedMonth: new Date().getMonth(),
    selectedCustomer: "_ALL_CUSTS__",
    selectedCustomerName: "",
    defaultSelected: {
      label: "All Customers",
      value: "_ALL_CUSTS__",
      ban: "_ALL_CUSTS__",
    },
    today: moment(new Date()).format("yyyy-MM-DD"),
    bread: [
      { title: this.props.t("REPORTS"), url: "/billingRecords" },
      { title: this.props.t("BILLING_RECORDS"), url: "/billingRecords" },
    ],
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.getBillingHistory();
    this.getCustomers();
    this.yearsList();
  }

  // Fetch orders list
  getBillingHistory = () => {
    this.setState({
      loading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    let fromDate = this.state.fromDate
      ? encodeURIComponent(this.convertDateParam(this.state.fromDate))
      : "";
    let toDate = this.state.toDate
      ? encodeURIComponent(this.convertTillDateParam(this.state.toDate))
      : "";
    let searchFilter = `agentId=${UriEncode(this.state.agentId)}&customerBAN=${UriEncode(this.state.customerBan)}&customerName=${UriEncode(this.state.customerName)}&featureCode=${UriEncode(this.state.featureCode)}&settlementProductId=${UriEncode(this.state.settlementId)}&orderId=${UriEncode(this.state.orderId)}&productName=${UriEncode(this.state.itemDescription)}&fromDate=${fromDate}&toDate=${toDate}`;
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/billing/views/summary?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&${searchFilter}`,
      {},
      pageOptions,
    )
      .then((res) => {
        let data = JSON.parse(res.data.jsonResponse);
        console.log("check data", data.billingHistoryList);
        this.setState({
          billingHistoryList: data.billingHistoryList,
          totalHistoryCount: +res.data["x-total-count"],
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  convertDateParam(date) {
    return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
  }

  convertTillDateParam(date) {
    return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
  }

  prependZero(numToChange) {
    var retNum = parseInt(numToChange);
    retNum = retNum < 10 ? "0" + retNum : retNum;
    return retNum;
  }

  isValidDate(dateString) {
    if (!dateString) {
      return true;
    }
    // First check for the pattern
    if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

    // Parse the date parts to integers
    var parts = dateString.split("/");
    var day = parseInt(parts[1], 10);
    var month = parseInt(parts[0], 10);
    var year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
      monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
  }

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getBillingHistory();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getBillingHistory();
      },
    );
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getBillingHistory();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getBillingHistory();
        },
      );
    }
  };

  // Update state data on input change
  onChange = (e) => {
    if (e.target.name === "fromDate") {
      this.setState({
        toDate: "",
      });
    }
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Search/Filter orders
  filterTable = () => {
    this.props.setErrorMessage("", false);
    this.setState({
      fromDateISO: "",
      toDateISO: "",
    });
    // if (this.isValidDate(this.state.fromDate) && this.isValidDate(this.state.toDate)) {
    //     if (this.state.fromDate) {
    //         var dateParts = this.state.fromDate.split("/");
    //         var tempDateISO = dateParts[2] + "-" + this.prependZero(dateParts[0]) + "-" + this.prependZero(dateParts[1]) + "T00:00:00:000+00:00";
    //         this.setState({
    //             fromDateISO: encodeURIComponent(tempDateISO)
    //         })
    //     }
    //     if (this.state.toDate) {
    //         var dateParts = this.state.toDate.split("/");
    //         var tempDateISO = dateParts[2] + "-" + this.prependZero(dateParts[0]) + "-" + this.prependZero(dateParts[1]) + "T23:59:59:000+00:00";
    //         this.setState({
    //             toDateISO: encodeURIComponent(tempDateISO)
    //         })
    //     }
    this.setState(
      {
        page: 1,
        startRecord: 1,
        // customerBan: '',
        // customerName: '',
        // featureCode: '',
        // settlementId: '',
        // itemDescription: '',
      },
      () => {
        this.getBillingHistory();
      },
    );
    // }
    // else {
    //     this.props.setErrorMessage("Please make sure the fromDate and toDate are in proper format (MM/DD/YYYY)", false)
    //     this.setState({ loading: false })
    // }
  };

  // Clear all search filters
  clearFilters = () => {
    this.props.setErrorMessage("", false);
    this.setState(
      {
        agentId: "",
        customerBan: "",
        customerName: "",
        featureCode: "",
        settlementId: "",
        orderId: "",
        itemDescription: "",
        fromDate: "",
        toDate: "",
        fromDateISO: "",
        toDateISO: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getBillingHistory();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterTable();
    }
  };

  changeTab = (e, newValue) => {
    this.setState({
      tabValue: newValue,
    });
  };

  createCsv = () => {
    this.setState({
      loading: true,
    });
    for (let i = 0; i < this.state.customersList.length; i++) {
      if (this.state.customersList[i].ban === this.state.selectedCustomer) {
        this.setState({
          selectedCustomerName: this.state.customersList[i].accountName,
        });
        break;
      } else {
        this.setState({
          selectedCustomerName: this.props.t("ALL_CUSTOMERS"),
        });
      }
    }
    BusApiCall(
      "GET",
      `${constants.busInternalUrl}/billing/customers/${this.state.selectedCustomer}/views/summary/monthly?billingMonth=${this.state.selectedMonth}&billingYear=${this.state.selectedYear}`,
    )
      .then((res) => {
        let data = decodeURIComponent(res.data.csvData);
        this.setState({
          csvData: data,
          download: true,
          loading: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("BIILING_RECORD_FETCH_ERROR"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getCustomers = () => {
    // this.setState({ loading: true })
    BusApiCall("GET", `${constants.busInternalUrl}/customers`)
      .then((res) => {
        let list = res.data.customers.map((a) => {
          return {
            ...a,
            label: `BAN #${a.ban} - ${a.accountName}`,
            value: a.ban,
          };
        });
        let allCustomers = {
          label: this.props.t("ALL_CUSTOMERS"),
          value: "_ALL_CUSTS__",
          ban: "_ALL_CUSTS__",
        };
        let finalList = [allCustomers].concat(list);
        this.setState({
          customersList: finalList,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false, totalCount: 0 });
      });
  };

  yearsList = () => {
    var currentYear = new Date().getFullYear(),
      years = [];
    let startYear = 2020;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    this.setState({
      yearsList: years,
    });
  };

  onChangeCsvFilter = (e) => {
    this.setState({
      download: false,
      [e.target.name]: e.target.value,
    });
  };

  onBanSelect = (e) => {
    this.setState({
      download: false,
      selectedCustomer: e.ban,
      defaultSelected: e,
    });
  };

  // Render order view
  render() {
    const t = this.props.t;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          <AppBar position="static" color="transparent" elevation={0}>
            <Tabs value={this.state.tabValue} onChange={this.changeTab}>
              <Tab
                classes={{ wrapper: classes.tabLabel }}
                label={t("BILLING_REPORT")}
              />
              <Tab
                classes={{ wrapper: classes.tabLabel }}
                label={t("MONTHLY_BILLING_REPORT")}
              />
            </Tabs>
          </AppBar>
          <Paper className="tablePaper" elevation={0}>
            <TabPanel
              value={this.state.tabValue}
              index={0}
              className={"tableTabpanelContent"}
            >
              {/* Search filters start */}
              {/* <Breadcrumb list={this.state.bread} /> */}
              <div
                className={classes.searchOuterDiv}
                style={{ marginBottom: "5px" }}
              >
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("ORDER_ID")}
                    value={this.state.orderId}
                    name={"orderId"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.ordInputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("PRODUCT_NAME")}
                    value={this.state.itemDescription}
                    name={"itemDescription"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("PRODUCT_CODE")}
                    value={this.state.featureCode}
                    name={"featureCode"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.fcInputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("CUSTOMER_NAME")}
                    value={this.state.customerName}
                    name={"customerName"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.inputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
                {this.props.providerType === "SALES_CHNL_PROVIDER" && (
                  <div>
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("CUSTOMER_BAN")}
                      value={this.state.customerBan}
                      name={"customerBan"}
                      onChange={(e) => {
                        this.onChange(e);
                      }}
                      divClass={classes.inputClass}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                    />
                  </div>
                )}
                <div>
                  <Input
                    size={"small"}
                    variant={"outlined"}
                    placeholder={t("AGENT_ID")}
                    value={this.state.agentId}
                    name={"agentId"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    divClass={classes.agInputClass}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                  />
                </div>
                <div>
                  <TextField
                    name="fromDate"
                    id="fromDate"
                    type="date"
                    value={this.state.fromDate}
                    label={t("FROM_DATE")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant={"outlined"}
                    size={"small"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    inputProps={{ max: this.state.today, format: "MM/dd/yyyy" }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    // className={classes.dateInputClass}
                  />
                </div>

                <div>
                  <TextField
                    name="toDate"
                    id="toDate"
                    type="date"
                    value={this.state.toDate}
                    label={t("TO_DATE")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    variant={"outlined"}
                    size={"small"}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                    inputProps={{
                      max: this.state.today,
                      min: this.state.fromDate,
                      format: "MM/dd/yyyy",
                    }}
                    onKeyDown={(e) => {
                      this.onSearchKeyDown(e);
                    }}
                    // className={classes.dateInputClass}
                  />
                </div>

                {/* <div className={classes.searchOrderLabelOuter} style={{ paddingRight: 0 }}>
                                    <div className={classes.searchOrderLabelInner} style={{ paddingRight: 0 }}> */}
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <Tooltip title={t("SEARCH")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={this.filterTable}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Tooltip>{" "}
                  &nbsp;
                  <Tooltip title={t("CLEAR")}>
                    <IconButton
                      className="iconButtonSecondary"
                      onClick={this.clearFilters}
                    >
                      <ClearIcon />
                    </IconButton>
                  </Tooltip>
                </div>
                {/* </div> */}
              </div>
              <BillingHistoryTable
                list={this.state.billingHistoryList}
                isValidDate={this.isValidDate}
                rowsPerPage={this.state.rowsPerPage}
                totalHistoryCount={this.state.totalHistoryCount}
                page={this.state.page}
                handleChangePage={this.handleChangePage}
                handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                sortBy={this.state.sortBy}
                sortOrder={this.state.sortOrder}
                updateSorting={this.updateSorting}
                providerType={this.props.providerType}
              />
              <Loader loading={this.state.loading} />
            </TabPanel>
            <TabPanel
              value={this.state.tabValue}
              index={1}
              className={"tableTabpanelContent"}
            >
              {/* Search filters start */}
              <div className={classes.searchOuterDivFilter}>
                <div style={{ marginTop: "25px" }}>
                  <BanSelect
                    onSelect={this.onBanSelect}
                    selected={this.state.defaultSelected}
                    defaultValue={this.state.defaultSelected}
                    customers={this.state.customersList}
                  />
                </div>
                <div style={{ marginTop: "25px" }}>
                  <FormControl
                    variant="outlined"
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      {t("Select Month")}
                    </InputLabel>
                    <Select
                      native
                      label="Select Month"
                      size={"small"}
                      variant={"outlined"}
                      name={"selectedMonth"}
                      inputProps={{
                        name: "selectedMonth",
                        id: "outlined-native-selectedMonth",
                      }}
                      //value={(a) => a.value}
                      value={this.state.selectedMonth}
                      onChange={(e) => {
                        this.onChange(e);
                      }}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                      selectClass={
                        orderClasses.inputClass +
                        " " +
                        orderClasses.statusSelectBg +
                        " " +
                        orderClasses.searchOrderSelect
                      }
                    >
                      {this.state.monthList.map((a) => (
                        <option key={a.value} value={a.value}>
                          {a.name}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={{ marginTop: "25px" }}>
                  <FormControl
                    variant="outlined"
                    className="custom-select-input"
                    size={"small"}
                  >
                    <InputLabel htmlFor="outlined-age-native-simple">
                      {t("Select Year")}
                    </InputLabel>
                    <Select
                      native
                      size={"small"}
                      label="Select year"
                      variant={"outlined"}
                      name={"selectedYear"}
                      inputProps={{
                        name: "selectedYear",
                        id: "outlined-native-selectedYear",
                      }}
                      //value={(a) => a.value}
                      value={this.state.selectedYear}
                      onChange={(e) => {
                        this.onChange(e);
                      }}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                      selectClass={
                        orderClasses.inputClass +
                        " " +
                        orderClasses.statusSelectBg +
                        " " +
                        orderClasses.searchOrderSelect
                      }
                    >
                      {this.state.yearsList.map((a) => (
                        <option key={a} value={a}>
                          {a}
                        </option>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div>
                  <div className={classes.searchOrderLabelOuter}>
                    <div className={classes.searchOrderLabelInner}>
                      <Button
                        onClick={this.createCsv}
                        style={{ marginTop: "15px" }}
                      >
                        {t("SEARCH")}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ clear: "both" }}></div>
              <div>
                <br />
                {this.state.download && (
                  <>
                    {t("YOUR_FILE_IS_READY_PLEASE_CLICK_ON_DOWNLOAD")} &nbsp;
                    <label>
                      <CSVLink
                        data={this.state.csvData}
                        filename={`${this.state.selectedCustomerName ? this.state.selectedCustomerName : "AllCustomers"}-${this.state.monthList[this.state.selectedMonth].name}-${this.state.selectedYear}.csv`}
                        className="button"
                        target="_blank"
                      >
                        {t("DOWNLOAD")}
                      </CSVLink>
                    </label>
                  </>
                )}
              </div>
              {/* {this.state.download &&
                            <CSVDownload data={this.state.csvData} target="_blank" filename={`${this.state.selectedCustomer}-${this.state.selectedMonth}-${this.state.selectedYear}.csv`} />
                        } */}
            </TabPanel>
          </Paper>
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerType: state.auth.providerType,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(BillingHistory));
